import { render, staticRenderFns } from "./OptionspropSelect.vue?vue&type=template&id=2cad4133"
import script from "./OptionspropSelect.vue?vue&type=script&lang=js"
export * from "./OptionspropSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports